import trans from '@astina/paloma-common-ui/src/services/Translator';
import palomaBackend from "@astina/paloma-common-ui/src/services/PalomaBackend";
import { handleHttpError } from "@astina/paloma-common-ui/src/services/Alerts";
import env from "../services/AppEnv";
const http = palomaBackend.http;
class ShopImportProfileRepository {
    list(searchRequest, page) {
        function toGridItemStatus(status) {
            if (status === 'inactive') {
                return 'disabled';
            }
            return 'neutral';
        }
        return http
            .get('orders/shop/import/profiles', {
            params: {
                page: page.number,
                size: page.size,
                sort: page.sort || 'name,asc',
                locale: env.locale,
            }
        })
            .then((response) => {
            const data = response.data;
            const page = {
                content: data.content.map((profile) => {
                    return {
                        id: profile.id,
                        title: profile.name,
                        topic: profile._meta.template.info.label,
                        status: toGridItemStatus(profile.status),
                        attributes: {
                            id: profile.id,
                            name: profile.name,
                            status: profile.status,
                            template: profile._meta.template.info.label,
                            format: profile._meta.consumes,
                            createdAt: profile.createdAt,
                            createdBy: profile.createdBy,
                            modifiedAt: profile.modifiedAt,
                            modifiedBy: profile.modifiedBy,
                        }
                    };
                }),
                number: data.number,
                size: data.size,
                totalElements: data.totalElements,
                totalPages: data.totalPages,
            };
            return page;
        })
            .catch(handleHttpError);
    }
    get(id) {
        return http.get(`orders/shop/import/profiles/${id}`, { params: { locale: env.locale } })
            .then((response) => {
            return response.data;
        })
            .catch(handleHttpError);
    }
    save(profile) {
        if (profile.id === null) {
            return http.post('orders/shop/import/profiles', profile)
                .then((response) => {
                return response.data;
            })
                .catch(handleHttpError);
        }
        return http.put(`orders/shop/import/profiles/${profile.id}`, profile)
            .then((response) => {
            return response.data;
        })
            .catch(handleHttpError);
    }
    delete(id) {
        return http.delete(`orders/shop/import/profiles/${id}`)
            .then((response) => {
            return response.data;
        })
            .catch(handleHttpError);
    }
    generateInputPassword(id, disable) {
        const params = {};
        if (disable !== undefined) {
            params.disable = disable;
        }
        return http.post(`orders/shop/import/profiles/${id}/generate-input-password`, { params: params })
            .then((response) => {
            return response.data;
        })
            .catch(handleHttpError);
    }
    listTemplates() {
        return http.get('orders/import/templates', { params: { locale: env.locale } })
            .then((response) => {
            return response.data;
        })
            .catch(handleHttpError);
    }
    listReaders() {
        return http.get('orders/import/readers', { params: { locale: env.locale } })
            .then((response) => {
            return response.data;
        })
            .catch(handleHttpError);
    }
    getReader(name) {
        return http.get('orders/import/readers', { params: { locale: env.locale } })
            .then((response) => {
            const reader = response.data.find((r) => r.info.name === name);
            if (reader === null) {
                throw `Reader not found for name: ${name}`;
            }
            return reader;
        })
            .catch(handleHttpError);
    }
    listBinders() {
        return http.get('orders/import/binders', { params: { locale: env.locale } })
            .then((response) => {
            return response.data;
        })
            .catch(handleHttpError);
    }
    getBinder(name) {
        return http.get('orders/import/binders', { params: { locale: env.locale } })
            .then((response) => {
            const binder = response.data.find((b) => b.info.name === name);
            if (binder === null) {
                throw `Binder not found for name: ${name}`;
            }
            return binder;
        })
            .catch(handleHttpError);
    }
    listProcessors() {
        return http.get('orders/import/processors', { params: { locale: env.locale } })
            .then((response) => {
            return response.data;
        })
            .catch(handleHttpError);
    }
    getProcessor(name) {
        return http.get('orders/import/processors', { params: { locale: env.locale } })
            .then((response) => {
            const source = response.data.find((s) => s.info.name === name);
            if (source === null) {
                throw `Processor not found for name: ${name}`;
            }
            return source;
        })
            .catch(handleHttpError);
    }
    getGridConfig() {
        return Promise.resolve({
            name: 'import-profiles',
            capabilities: {
                search: false,
                bulkOperations: false,
            },
            columns: [
                {
                    name: 'name',
                    label: trans('import_profile.name'),
                    dataType: 'text',
                    visible: false,
                    sortable: false,
                    size: 'm'
                },
                {
                    name: 'status',
                    label: trans('import_profile.status'),
                    dataType: 'text',
                    visible: true,
                    sortable: false,
                    size: 'm'
                },
                {
                    name: 'template',
                    label: trans('import_profile.template'),
                    dataType: 'text',
                    visible: true,
                    sortable: false,
                    size: 'm'
                },
                {
                    name: 'createdAt',
                    label: trans('created_at'),
                    dataType: 'datetime',
                    visible: false,
                    sortable: false,
                    size: 'm'
                },
                {
                    name: 'createdBy',
                    label: trans('created_by'),
                    dataType: 'text',
                    visible: false,
                    sortable: false,
                    size: 'm'
                },
                {
                    name: 'modifiedAt',
                    label: trans('modified_at'),
                    dataType: 'datetime',
                    visible: false,
                    sortable: false,
                    size: 'm'
                },
                {
                    name: 'modifiedBy',
                    label: trans('modified_by'),
                    dataType: 'text',
                    visible: false,
                    sortable: false,
                    size: 'm'
                },
            ],
            filters: [],
        });
    }
    getGridItemsSource() {
        return {
            get: this.list
        };
    }
}
export default new ShopImportProfileRepository();
